import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import { useForm, Field } from 'react-final-form';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { H3 } from '@piconetworks/pkg-heading';
import { P } from '@piconetworks/pkg-text';
import { format } from '@piconetworks/pkg-currency';
import Form from '@piconetworks/pkg-form';
import Picon from '@piconetworks/pkg-picon';
import { AnnualPercentDiscount } from '@piconetworks/pkg-functions';
import style from './scss/SelectPledge.module.scss.js';
import { RemoteJsonText } from '@piconetworks/pkg-remote-markdown';
import { selectors } from '@piconetworks/pkg-module-loader';

var _excluded = ["fieldContainerProps", "required", "name", "linkColor", "contrastColor", "isGift", "product", "className", "giftCta", "customFeaturesUrl", "setCustomPrice"];
var SelectPledge = function SelectPledge(props) {
  var _product$options, _form$getState$values;
  var fieldContainerProps = props.fieldContainerProps,
    required = props.required,
    name = props.name,
    _props$linkColor = props.linkColor,
    linkColor = _props$linkColor === void 0 ? '' : _props$linkColor,
    _props$contrastColor = props.contrastColor,
    contrastColor = _props$contrastColor === void 0 ? '' : _props$contrastColor,
    _props$isGift = props.isGift,
    isGift = _props$isGift === void 0 ? false : _props$isGift,
    _props$product = props.product,
    product = _props$product === void 0 ? {} : _props$product,
    className = props.className,
    _props$giftCta = props.giftCta,
    giftCta = _props$giftCta === void 0 ? function () {} : _props$giftCta,
    _props$customFeatures = props.customFeaturesUrl,
    customFeaturesUrl = _props$customFeatures === void 0 ? '' : _props$customFeatures,
    _props$setCustomPrice = props.setCustomPrice,
    setCustomPrice = _props$setCustomPrice === void 0 ? function () {} : _props$setCustomPrice,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var _useState = useState(true),
    isAnnualChecked = _useState[0],
    toggleAnnualChecked = _useState[1];
  var _useState2 = useState(false),
    isCustomFieldAction = _useState2[0],
    toggleCustomField = _useState2[1];
  var _selectors = selectors(),
    priceText = _selectors.priceText;
  var form = useForm();
  useEffect(function () {
    var annual = product.options.some(function (option) {
      return option.default_option && option.interval === 'year';
    });
    toggleAnnualChecked(annual);
  }, Array.isArray(product.options) ? product.options : []);
  var title = product === null || product === void 0 ? void 0 : product.title;
  var formattedOptions = (product === null || product === void 0 ? void 0 : (_product$options = product.options) === null || _product$options === void 0 ? void 0 : _product$options.reduce(function (selections, _ref) {
    var value = _ref.id,
      interval = _ref.interval,
      amount = _ref.price,
      currencyCode = _ref.currency;
    var price = priceText(format({
      currencyCode: currencyCode,
      amount: amount,
      symbol: false
    }), currencyCode);
    var text = isGift ? "Gift the first " + interval : 'Pledge';
    selections[interval] = {
      value: value,
      text: text,
      price: price,
      amount: amount,
      interval: interval,
      currencyCode: currencyCode
    };
    return selections;
  }, {})) || [];
  var showPlanIntervalSwitch = Object.keys(formattedOptions).length > 1;
  var selectedPlan = showPlanIntervalSwitch ? isAnnualChecked ? formattedOptions.year : formattedOptions.month : formattedOptions[Object.keys(formattedOptions)[0]];
  var text = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.text;
  var price = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.price;
  var value = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.value;
  var amount = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.amount;
  var interval = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.interval;
  var _useState3 = useState(),
    pledgePrice = _useState3[0],
    setPledgePrice = _useState3[1];
  var planCustomPrice = "customPrice_" + value;
  var selectedCustomPrice = (_form$getState$values = form.getState().values) === null || _form$getState$values === void 0 ? void 0 : _form$getState$values[planCustomPrice];
  useEffect(function () {
    toggleCustomField(false);
    setCustomPrice(amount);
    setPledgePrice((amount / 100).toFixed(2));
  }, [JSON.stringify(selectedPlan)]);
  var savings;
  if (showPlanIntervalSwitch) {
    var _formattedOptions$mon, _formattedOptions$yea;
    var monthlyPrice = formattedOptions === null || formattedOptions === void 0 ? void 0 : (_formattedOptions$mon = formattedOptions.month) === null || _formattedOptions$mon === void 0 ? void 0 : _formattedOptions$mon.amount;
    var annualPrice = formattedOptions === null || formattedOptions === void 0 ? void 0 : (_formattedOptions$yea = formattedOptions.year) === null || _formattedOptions$yea === void 0 ? void 0 : _formattedOptions$yea.amount;
    savings = annualPrice < monthlyPrice * 12 && AnnualPercentDiscount(monthlyPrice, annualPrice);
  }
  return /*#__PURE__*/React.createElement(Form.Field, fieldContainerProps, /*#__PURE__*/React.createElement("div", {
    className: classNames(style.container, className)
  }, title && /*#__PURE__*/React.createElement("div", {
    className: style.header
  }, /*#__PURE__*/React.createElement(H3, {
    className: style.title
  }, title), /*#__PURE__*/React.createElement("div", {
    className: style.priceContainer
  }, /*#__PURE__*/React.createElement(H3, {
    className: style.price
  }, price), /*#__PURE__*/React.createElement("small", null, "per ", interval))), /*#__PURE__*/React.createElement("div", {
    className: style.dflex
  }, /*#__PURE__*/React.createElement("div", {
    className: style.col6
  }, customFeaturesUrl && /*#__PURE__*/React.createElement(RemoteJsonText, {
    url: customFeaturesUrl,
    style: style,
    linkColor: linkColor
  })), /*#__PURE__*/React.createElement("div", {
    className: style.col6
  }, /*#__PURE__*/React.createElement("div", null, showPlanIntervalSwitch && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Radio, {
    type: "radio",
    text: 'Monthly',
    input: {
      onChange: function onChange() {
        toggleAnnualChecked(false);
      },
      checked: interval === 'month',
      type: 'radio'
    }
  }), /*#__PURE__*/React.createElement(Form.Radio, {
    type: "radio",
    text: "Annual" + (savings ? " (Save " + savings + "%)" : ''),
    input: {
      onChange: function onChange() {
        toggleAnnualChecked(true);
      },
      checked: interval === 'year',
      type: 'radio'
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: style.dflex,
    onClick: function onClick(e) {
      if (!isCustomFieldAction) {
        e.preventDefault();
        e.stopPropagation();
        toggleCustomField(!isCustomFieldAction);
      }
    }
  }, isCustomFieldAction && /*#__PURE__*/React.createElement(Field, {
    name: "customPrice_" + selectedPlan.value,
    validate: function validate(value, allValues, meta) {
      return Number(value) < amount && meta.active ? "Amount must be at least " + price + "." : undefined;
    }
  }, function (_ref2) {
    var input = _ref2.input,
      meta = _ref2.meta;
    return /*#__PURE__*/React.createElement("div", {
      className: style.passwordInput
    }, /*#__PURE__*/React.createElement(Form.FormatInput, {
      meta: meta,
      symbol: false,
      formatType: "currency",
      label: "",
      inputPrefix: "$",
      placeholder: "0.00",
      customPrice: "true",
      value: pledgePrice,
      initialValue: pledgePrice,
      input: {
        customPrice: true,
        defaultValue: pledgePrice,
        onChange: function onChange(el) {
          if (typeof el === 'object') {
            var _el$target;
            var _value = el === null || el === void 0 ? void 0 : (_el$target = el.target) === null || _el$target === void 0 ? void 0 : _el$target.value;
            input.onChange(Object.assign({}, el, {
              target: Object.assign({}, el.target, {
                value: Number(_value.split(',').join('').split('.').join(''))
              })
            }));
            setPledgePrice(_value);
          } else {
            setPledgePrice(el);
          }
        }
      }
    }));
  }), /*#__PURE__*/React.createElement(Field, _extends({}, required && {
    validate: function validate(value) {
      return value ? undefined : 'Required';
    }
  }, {
    name: name,
    render: function render(props) {
      var _classNames, _classNames2;
      return /*#__PURE__*/React.createElement(Form.Radio, _extends({}, props, {
        className: classNames('btn', style.btn, (_classNames = {}, _classNames[style.fix] = isCustomFieldAction, _classNames)),
        style: {
          color: contrastColor
        },
        fieldProps: {
          className: classNames('btn', style.btn, (_classNames2 = {}, _classNames2[style.fix] = isCustomFieldAction, _classNames2))
        }
      }));
    },
    value: value,
    text: isCustomFieldAction ? /*#__PURE__*/React.createElement(Picon, {
      icon: "arrow-right",
      color: "white",
      size: "25"
    }) : text,
    type: "radio",
    disabled: selectedCustomPrice < amount
  }, rest))), !isGift && /*#__PURE__*/React.createElement(P, {
    className: style['link-text'],
    onClick: function onClick() {
      return giftCta(value);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-icon_gift"
  }), /*#__PURE__*/React.createElement("span", null, "Gift"))))));
};
SelectPledge.propTypes = {
  className: PropTypes.string,
  contrastColor: PropTypes.string,
  customFeaturesUrl: PropTypes.string,
  description: PropTypes.string,
  fieldContainerProps: PropTypes.shape({
    label: PropTypes.string,
    required: PropTypes.bool
  }),
  giftCta: PropTypes.func,
  isGift: PropTypes.bool,
  linkColor: PropTypes.string,
  name: PropTypes.string,
  product: PropTypes.object,
  required: PropTypes.bool,
  setCustomPrice: PropTypes.func,
  themeColor: PropTypes.string
};

export { SelectPledge as default };
//# sourceMappingURL=index.js.map
